export default "__VITE_ASSET__g3vXBJ3o__"